var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"There are medications you can take after you have sex to prevent HIV infection.","answer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }